import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import "./fiu.css";
import FiuProcess from "./FiuProcess";
import FIUBenefits from "./FIUBenefits";

const FIU = () => {
  return (
    <>
      <header>
        <NewHead />
      </header>

      <Helmet>
        <title>FIU Consultant | FIU Registration</title>

        <meta name="title" content="FIU Consultant | FIU Registration" />
        <meta
          name="description"
          content="We guide businesses through AML/CTF policies, documentation, and audits for smooth operations. Partner with experts to meet legal standards and drive growth. Get your FIU-IND registration done in no time."
        />

        <meta property="og:title" content="FIU Consultant | FIU Registration" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/fiu-consultant"
        />
      </Helmet>

      <main className="landingMain about-us pb-1">
        <div className="primary__landing__container">
          {/* hero */}
          <div className="fiu-wrapper">
            <h1 className="fiu-hero-title">
              FIU Consultant | FIU Registration
            </h1>
            <p className="fiu-hero-content">
              Expert guidance for seamless FIU-IND registration, ensuring
              compliance with financial regulations. Trusted partner for
              efficient and hassle-free processes.
            </p>
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="mt-2 career-btn"
            >
              Get Free Consultation{" "}
              <span className="mx-2 right-arr">
                <i className="fa-solid fa-arrow-right"></i>
              </span>
            </button>
          </div>

          {/* about */}
          <div className="about-join-container">
            <div className="row">
              <div className="col-lg-3">
                <div>
                  <h5 className="career-join-title text-capitalize">
                    What is FIU?{" "}
                  </h5>
                </div>
              </div>
              <div className="col-lg-9">
                <div className="career-join-content">
                  <p>
                    <span>
                      The Financial Intelligence Unit - India (FIU-IND) is a
                      government agency responsible for tracking and combating
                      financial crimes such as money laundering, terrorism
                      financing, and other illicit financial activities. It
                      operates under the Department of Revenue, Ministry of
                      Finance, and ensures compliance with anti-money laundering
                      (AML) and counter-terrorism financing (CTF) laws. As the
                      digital asset industry grows rapidly in India, businesses
                      involved in cryptocurrencies and blockchain technologies
                      must align themselves with legal frameworks. Obtaining a
                      FIU Registration is a crucial step for such businesses,
                      and FIU consultants play a key role in guiding them
                      through the process.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* registration */}
          <div className="fiu-reg-wrapper">
            <h4 className="fiu-reg-title">What is a FIU Registration?</h4>
            <p className="fiu-reg-content">
              A FIU Registration is a regulatory requirement for businesses
              operating in the cryptocurrency and digital asset sectors. This
              license ensures that these entities comply with AML and CTF
              regulations set by FIU-IND. Key stakeholders requiring this
              license include
            </p>

            <div className="fiu-reg-flex-one">
              <div className="fiu-reg-card">
                <div className="fiu-reg-card-img">
                  <img
                    src={require("../../../image/fiu/crypto-reg.webp")}
                    alt="FIU Consultant"
                  />
                </div>
                <h6 className="fiu-reg-card-title">Cryptocurrency Exchanges</h6>
              </div>
              <div className="fiu-reg-card">
                <div className="fiu-reg-card-img">
                  <img
                    src={require("../../../image/fiu/wallet-reg.webp")}
                    alt="FIU Consultant"
                  />
                </div>
                <h6 className="fiu-reg-card-title">Wallet Providers</h6>
              </div>
              <div className="fiu-reg-card">
                <div className="fiu-reg-card-img">
                  <img
                    src={require("../../../image/fiu/blockchain-reg.webp")}
                    alt="FIU Consultant"
                  />
                </div>
                <h6 className="fiu-reg-card-title">
                  Blockchain-Based Payment Platforms
                </h6>
              </div>
            </div>
            <div className="fiu-reg-flex-two">
              <div className="fiu-reg-card">
                <div className="fiu-reg-card-img">
                  <img
                    src={require("../../../image/fiu/defi-reg.webp")}
                    alt="FIU Consultant"
                  />
                </div>
                <h6 className="fiu-reg-card-title pad">DeFi Platforms</h6>
              </div>
              <div className="fiu-reg-card">
                <div className="fiu-reg-card-img">
                  <img
                    src={require("../../../image/fiu/nft-reg.webp")}
                    alt="FIU Consultant"
                  />
                </div>
                <h6 className="fiu-reg-card-title pad">NFT Marketplaces</h6>
              </div>
            </div>

            <p className="fiu-reg-content-two">
              The license not only enhances trust among customers but also
              ensures smooth business operations within the legal framework.
            </p>

            {/* <img
              src={require("../../../image/fiu/reg-flag.webp")}
              alt="FIU Consultant"
              className="reg-flag"
            /> */}
          </div>

          {/* need */}
          <div className="fiu-need-wrapper">
            <div className="row fiu-need-row">
              <div className="col-lg-6">
                <div className="fiu-need-left">
                  <h4 className="fiu-need-left-title">
                    Why Do You Need a FIU Consultant?
                  </h4>
                  <p className="fiu-need-left-content">
                    The process of obtaining a FIU Registration involves
                    multiple steps, documentation, and compliance checks. A FIU
                    consultant helps businesses navigate this complex process by
                  </p>
                  <p className="fiu-need-left-content">
                    With a reliable FIU consultant, businesses can avoid
                    potential legal issues and focus on their core operations.
                  </p>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="fiu-need-left-btn"
                  >
                    Get Free Consultation{" "}
                    <span className="mx-2 right-arr">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </button>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="fiu-need-right">
                  <div className="fiu-need-right-contents">
                    <img
                      src={require("../../../image/fiu/need-img-one.webp")}
                      alt="FIU Consultant"
                    />
                    <h6 className="fiu-need-right-title">
                      Ensuring adherence to AML and CTF guidelines
                    </h6>
                  </div>
                  <div className="fiu-need-right-contents">
                    <img
                      src={require("../../../image/fiu/need-img-two.webp")}
                      alt="FIU Consultant"
                    />
                    <h6 className="fiu-need-right-title">
                      Preparing and submitting necessary documents
                    </h6>
                  </div>
                  <div className="fiu-need-right-contents">
                    <img
                      src={require("../../../image/fiu/need-img-three.webp")}
                      alt="FIU Consultant"
                    />
                    <h6 className="fiu-need-right-title">
                      Guiding businesses through audits and inspections
                    </h6>
                  </div>
                  <div className="fiu-need-right-contents">
                    <img
                      src={require("../../../image/fiu/need-img-four.webp")}
                      alt="FIU Consultant"
                    />
                    <h6 className="fiu-need-right-title">
                      Providing legal and technical advice
                    </h6>
                  </div>
                  <div className="fiu-need-right-contents">
                    <img
                      src={require("../../../image/fiu/need-img-five.webp")}
                      alt="FIU Consultant"
                    />
                    <h6 className="fiu-need-right-title">
                      Helping with ongoing compliance requirements
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* key features */}
          <div className="fiu-key-wrapper">
            <div className="fiu-key-title-container">
              <h6 className="fiu-key-title">
                Key Services Offered by Beleaf technologies as an FIU Consultant
              </h6>
            </div>

            <div className="row fiu-key-row">
              <div className="col-lg-1"></div>
              <div className="col-lg-5"></div>
              <div className="col-lg-1"></div>
              <div className="col-lg-5">
                <div>
                  <div>
                    <img
                      src={require("../../../image/fiu/key-img-two.webp")}
                      alt="FIU Consultant"
                      className="fiu-key-img"
                    />
                  </div>
                  <h4 className="fiu-key-row-title">
                    Initial Assessment and Guidance
                  </h4>
                  <p className="fiu-key-row-content">
                    FIU consultants start by assessing your business model to
                    understand its specific requirements. This includes
                    identifying potential risks and gaps in compliance.
                  </p>
                </div>
              </div>
            </div>
            <div className="row fiu-key-row">
              <div className="col-lg-1"></div>
              <div className="col-lg-5">
                <div className="-mt-key-col">
                  <div>
                    <img
                      src={require("../../../image/fiu/key-img-one.webp")}
                      alt="FIU Consultant"
                      className="fiu-key-img"
                    />
                  </div>
                  <h4 className="fiu-key-row-title">
                    AML and CTF Compliance Setup
                  </h4>
                  <p className="fiu-key-row-content">
                    One of the most critical aspects of obtaining a FIU
                    Registration is compliance with AML and CTF regulations.
                    Consultants assist in:
                  </p>
                  <ul className="fiu-key-lists">
                    <li className="fiu-key-row-content">
                      Drafting AML policies
                    </li>
                    <li className="fiu-key-row-content">
                      Establishing KYC (Know Your Customer) processes
                    </li>
                    <li className="fiu-key-row-content">
                      Implementing transaction monitoring systems
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-1"></div>
              <div className="col-lg-5"></div>
            </div>

            <div className="row fiu-key-row">
              <div className="col-lg-1"></div>
              <div className="col-lg-5"></div>
              <div className="col-lg-1"></div>
              <div className="col-lg-5">
                <div>
                  <div>
                    <img
                      src={require("../../../image/fiu/key-img-four.webp")}
                      alt="FIU Consultant"
                      className="fiu-key-img"
                    />
                  </div>
                  <h4 className="fiu-key-row-title">Documentation Support</h4>
                  <p className="fiu-key-row-content">
                    Accurate documentation is key to getting approval from
                    FIU-IND. Consultants help in:
                  </p>
                  <ul className="fiu-key-lists">
                    <li className="fiu-key-row-content">
                      Preparing application forms
                    </li>
                    <li className="fiu-key-row-content">
                      Gathering and verifying required documents
                    </li>
                    <li className="fiu-key-row-content">
                      Submitting the application
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row fiu-key-row">
              <div className="col-lg-1"></div>
              <div className="col-lg-5">
                <div className="-mt-key-col-60">
                  <div>
                    <img
                      src={require("../../../image/fiu/key-img-three.webp")}
                      alt="FIU Consultant"
                      className="fiu-key-img"
                    />
                  </div>
                  <h4 className="fiu-key-row-title">Training and Awareness</h4>
                  <p className="fiu-key-row-content">
                    Consultants provide training to your team on AML and CTF
                    guidelines, ensuring everyone understands the importance of
                    compliance.
                  </p>
                </div>
              </div>
              <div className="col-lg-1"></div>
              <div className="col-lg-5"></div>
            </div>

            <div className="row fiu-key-row">
              <div className="col-lg-1"></div>
              <div className="col-lg-5"></div>
              <div className="col-lg-1"></div>
              <div className="col-lg-5">
                <div>
                  <div>
                    <img
                      src={require("../../../image/fiu/key-img-five.webp")}
                      alt="FIU Consultant"
                      className="fiu-key-img"
                    />
                  </div>
                  <h4 className="fiu-key-row-title">Post-License Support</h4>
                  <p className="fiu-key-row-content">
                    Even after obtaining the FIU Registration, businesses must
                    adhere to ongoing compliance requirements. Consultants help
                    in:
                  </p>
                  <ul className="fiu-key-lists">
                    <li className="fiu-key-row-content">
                      Filing periodic reports to FIU-IND
                    </li>
                    <li className="fiu-key-row-content">
                      Updating policies based on new regulations
                    </li>
                    <li className="fiu-key-row-content">
                      Conducting internal audits
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="fiu-overflow-hidden">
          <div className="primary__landing__container ">
            {/* step-by-step */}
            <div className="fiu-process-wrapper">
              <h6 className="fiu-process-title">
                Step-by-Step Process for Obtaining a FIU Registration
              </h6>

              <FiuProcess />
            </div>

            {/* Benefits */}
            <div className="fiu-benefits-wrapper">
              <h6 className="fiu-benefits-title ">
                Benefits of Working with a FIU Consultant
              </h6>

              <FIUBenefits />
            </div>

            {/* challanges */}
            <div className="fiu-challanges-wrapper">
              <h6 className="fiu-challanges-title">
                Challenges in <br /> Obtaining a FIU Registration
              </h6>
              <p className="fiu-challanges-content mt-4">
                While a FIU Registration offers numerous benefits, the process
                can be challenging due to:
              </p>

              <div className="row fiu-challanges-row mt-5">
                <div className="col-lg-6">
                  <div className="fiu-challanges-col">
                    <img
                      src={require("../../../image/fiu/challange-one.webp")}
                      alt="FIU Consultant"
                    />
                    <h4 className="fiu-challanges-sub-title">
                      Stringent regulatory requirements
                    </h4>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="fiu-challanges-col">
                    <img
                      src={require("../../../image/fiu/challange-two.webp")}
                      alt="FIU Consultant"
                    />
                    <h4 className="fiu-challanges-sub-title">
                      Frequent changes in regulations
                    </h4>
                  </div>
                </div>
              </div>
              <div className="row fiu-challanges-row">
                <div className="col-lg-6">
                  <div className="fiu-challanges-col">
                    <img
                      src={require("../../../image/fiu/challange-three.webp")}
                      alt="FIU Consultant"
                    />
                    <h4 className="fiu-challanges-sub-title">
                      Complex documentation
                    </h4>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="fiu-challanges-col">
                    <img
                      src={require("../../../image/fiu/challange-four.webp")}
                      alt="FIU Consultant"
                    />
                    <h4 className="fiu-challanges-sub-title">
                      Need for technical and legal expertise
                    </h4>
                  </div>
                </div>
              </div>

              <p className="fiu-challange-box-content">
                A FIU consultant helps overcome these challenges by providing
                professional guidance and support.
              </p>
            </div>

            {/* Hire */}
            <div className="fiu-hire-wrapper">
              <div className="row">
                <div className="col-lg-6 fiu-col-left">
                  <div className="fiu-hire-left">
                    <h6 className="fiu-hire-title">
                      Who Should <br /> Hire a FIU Consultant?
                    </h6>
                    <p className="fiu-hire-content">
                      FIU consultancy services are ideal for:
                    </p>

                    <ul className="fiu-hire-lists">
                      <li>Startups entering the cryptocurrency space</li>
                      <li>
                        Established businesses expanding into digital assets
                      </li>
                      <li>Companies facing compliance challenges</li>
                      <li>Organizations preparing for audits or inspections</li>
                    </ul>
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="fiu-need-left-btn"
                    >
                      Get Free Consultation{" "}
                      <span className="mx-2 right-arr">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button>

                    <img
                      src={require("../../../image/fiu/certified.webp")}
                      alt="FIU Consultant"
                      className="fiu-hire-img"
                    />
                  </div>
                </div>
                <div className="col-lg-6 fiu-col-right">
                  <div className="fiu-hire-right">
                    <img
                      src={require("../../../image/fiu/hire-right.webp")}
                      alt="FIU Consultant"
                      className="w-100 fiu-hire-mobile-img"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* digital assets */}
            <div className="fiu-digital-assets-wrapper">
              <h6 className="fiu-digital-title">
                FIU-IND Regulations for Digital Asset Businesses
              </h6>
              <div className="row fiu-digital-row">
                <div className="col-lg-3">
                  <div className="fiu-digital-cards">
                    <span>01</span>
                    <h5>Customer Due Diligence (CDD)</h5>
                    <p>
                      Businesses must verify customer identities and assess
                      potential risks.
                    </p>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="fiu-digital-cards">
                    <span>02</span>
                    <h5>Record Keeping</h5>
                    <p>
                      All transactions must be recorded and maintained for a
                      specified period.
                    </p>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="fiu-digital-cards">
                    <span>03</span>
                    <h5>Suspicious Transaction Reporting (STR)</h5>
                    <p>
                      Any suspicious activity must be reported to FIU-IND
                      promptly.
                    </p>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="fiu-digital-cards">
                    <span>04</span>
                    <h5>Periodic Reporting</h5>
                    <p>
                      Businesses must submit regular reports, including
                      financial statements and compliance updates.
                    </p>
                  </div>
                </div>
              </div>

              <div className="text-center">
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="fiu-need-left-btn"
                >
                  Get Free Consultation{" "}
                  <span className="mx-2 right-arr">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>

            {/* how-to-choose */}
            <div className="fiu-choose-wrapper">
              <h6 className="fiu-digital-title">
                How to Choose the Right FIU Consultant
              </h6>
              <div className="row fiu-choose-row">
                <div className="col-lg-3 col-md-6">
                  <div className="fiu-choose-cards">
                    <div className="choose-img-outer">
                      <img
                        src={require("../../../image/fiu/choose-one.webp")}
                        alt="FIU Consultant"
                      />
                    </div>
                    <h6 className="fiu-choose-card-title">Experience</h6>
                    <p className="fiu-choose-card-content">
                      Choose a consultant with proven experience in FIU
                      compliance and DASP licensing.
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="fiu-choose-cards">
                    <div className="choose-img-outer">
                      <img
                        src={require("../../../image/fiu/choose-two.webp")}
                        alt="FIU Consultant"
                      />
                    </div>
                    <h6 className="fiu-choose-card-title">Reputation</h6>
                    <p className="fiu-choose-card-content">
                      Check the portfolio to gauge the consultant's reliability.
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="fiu-choose-cards">
                    <div className="choose-img-outer">
                      <img
                        src={require("../../../image/fiu/choose-three.webp")}
                        alt="FIU Consultant"
                      />
                    </div>
                    <h6 className="fiu-choose-card-title">
                      Comprehensive Services
                    </h6>
                    <p className="fiu-choose-card-content">
                      Ensure the consultant offers end-to-end support, from
                      application to post-license compliance.
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="fiu-choose-cards">
                    <div className="choose-img-outer">
                      <img
                        src={require("../../../image/fiu/choose-four.webp")}
                        alt="FIU Consultant"
                      />
                    </div>
                    <h6 className="fiu-choose-card-title">
                      Transparent Pricing
                    </h6>
                    <p className="fiu-choose-card-content">
                      Look for consultants with clear and upfront pricing.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Take away */}
        <div className="fiu-takeaway-wrapper">
          <div className="primary__landing__container">
            <h6 className="fiu-take-away-title">Take Away</h6>
            <p className="fiu-take-away-content">
              A FIU consultant is an invaluable partner for businesses seeking
              to obtain a Digital Asset Service Provider license in India. From
              navigating complex regulations to ensuring ongoing compliance,
              their expertise simplifies the process and enables businesses to
              operate legally and efficiently. If you’re looking to start or
              expand your digital asset business, partnering with a trusted FIU
              consultant is the key to success. With their guidance, you can
              focus on innovation while staying compliant with all regulatory
              requirements.
            </p>
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="fiu-need-left-btn mt-5"
            >
              Get Free Consultation{" "}
              <span className="mx-2 right-arr">
                <i className="fa-solid fa-arrow-right"></i>
              </span>
            </button>
          </div>
          <img
            src={require("../../../image/fiu/certified.webp")}
            alt="FIU Consultant"
            className="fiu-ceritified-img"
          />
        </div>
      </main>

      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          What is the role of FIU-IND?
                        </a>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          FIU-IND tracks and prevents financial crimes like
                          money laundering and terrorism financing by enforcing
                          AML and CTF regulations.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          Who needs a FIU Registration in India?
                        </a>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Businesses involved in digital assets, such as
                          cryptocurrency exchanges, wallet providers, and NFT
                          marketplaces, require a FIU Registration.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          How long does it take to obtain a FIU Registration?
                        </a>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The timeline varies depending on the complexity of the
                          application and compliance requirements, but
                          consultants can expedite the process.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq44"
                        >
                          What happens if a business fails to comply with
                          FIU-IND regulations?
                        </a>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Non-compliance can lead to penalties, license
                          revocation, and reputational damage.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead5">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq5"
                          aria-expanded="true"
                          aria-controls="faq5"
                        >
                          Can a FIU consultant help with ongoing compliance?
                        </a>
                      </div>

                      <div
                        id="faq5"
                        className="collapse"
                        aria-labelledby="faqhead5"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, consultants provide continuous support to ensure
                          your business remains compliant with all regulations.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default FIU;
